import Vue from 'vue'
import Router from 'vue-router'
import Landing from './views/Landing.vue'
import NotFoundPage from './views/NotFoundPage.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing,
      needAuth: false
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      needAuth: false
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      needAuth: false
    },
    {
      path: '/confirmregistration/:registrationuid',
      name: 'confirmregistration',
      props: true,
      component: () => import(/* webpackChunkName: "confirmregistration" */ './views/ConfirmRegistration.vue'),
      needAuth: false
    },
    {
      path: '/restorepassword',
      name: 'restorepassword',
      component: () => import(/* webpackChunkName: "restorepassword" */ './views/RestorePassword.vue'),
      needAuth: false
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import(/* webpackChunkName: "pay" */ './views/Pay.vue'),
      needAuth: false
    },
    {
      path: '/additionalservices',
      name: 'additionalservices',
      component: () => import(/* webpackChunkName: "additionalservices" */ './views/AdditionalServices.vue'),
      needAuth: false
    },
    // {
    //   path: '/sms',
    //   name: 'sms',
    //   component: () => import(/* webpackChunkName: "sms" */ './views/Sms.vue'),
    //   needAuth: false
    // },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
      needAuth: true
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import(/* webpackChunkName: "messages" */ './views/Messages.vue'),
      needAuth: true
    },
    {
      path: '/statements',
      name: 'statements',
      component: () => import(/* webpackChunkName: "statements" */ './views/Statements.vue'),
      needAuth: true
    },
    {
      path: '/transfers',
      name: 'transfers',
      component: () => import(/* webpackChunkName: "transfers" */ './views/Transfers.vue'),
      needAuth: true
    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './views/Events.vue'),
      needAuth: true
    },
    {
      path: '/question',
      name: 'question',
      component: () => import(/* webpackChunkName: "question" */ './views/Question.vue'),
      needAuth: false
    },
    {
      path: '/support',
      name: 'support',
      component: () => import(/* webpackChunkName: "Support" */ './views/Support.vue'),
      needAuth: false
    },
    // {
    //   path: '/qr/sber',
    //   name: 'qrsber',
    //   component: () => import(/* webpackChunkName: "qrsber" */ './views/QrSber.vue'),
    //   needAuth: false
    // },
    {
      path: '/confirmemail',
      name: 'confirmemail',
      component: () => import(/* webpackChunkName: "confirmemail" */ './views/ConfirmEmail.vue'),
      needAuth: false
    },
    {
      path: '/rejectemail',
      name: 'rejectemail',
      component: () => import(/* webpackChunkName: "rejectemail" */ './views/RejectEmail.vue'),
      needAuth: false
    },
    {
      path: '/sberid/callback',
      name: 'SberIdCallback',
      component: () => import(/* webpackChunkName: "sberidcallback" */ './views/SberIdCallback.vue'),
      needAuth: false
    },
    {
      path: '*', component: NotFoundPage
    }
  ]
})
